angular.module('env.data.requestCoupler.requestCouplerProvider', [])

    .provider('requestCoupler', function () {
        var requestCouplerProvider = this;
        var defaultDelay = 100;

        var defaultCouplerConfig = {
            maxCouplerQueueSize: 10,
            minCouplerQueueSize: 2,
            delay: defaultDelay
        };

        var serviceConfig = {
            enabled: false
        };

        var couplers = [];

        /**
         * Set default configuration for request couplers
         * @param {{
         *   [maxCouplerQueueSize]: number,
         *   [minCouplerQueueSize]: number,
         *   [delay]: number
         *   }} config configuration object
         */
        function setDefaultCouplerConfig(config) {
            if (config) {
                angular.extend(defaultCouplerConfig, config);
            }
        }

        /**
         * Set requestCoupler provider configuration
         * @param {{enabled: boolean}} config configuration object
         */
        function setConfig(config) {
            if (config) {
                angular.extend(serviceConfig, config);
            }
        }

        /**
         * Add new coupler
         * @param {{
         *   [maxCouplerQueueSize]: number,
         *   [minCouplerQueueSize]: number,
         *   [delay]: number,
         *   check: function,
         *   process: function
         * }} coupler
         */
        function addCoupler(coupler) {
            couplers.push(angular.extend({}, defaultCouplerConfig, coupler));
        }

        /**
         * Get couplers collection
         * @returns {Array}
         */
        function getCouplers() {
            return couplers;
        }

        function isEnabled() {
            return serviceConfig.enabled === true || serviceConfig.enabled === 'true';
        }

        angular.extend(requestCouplerProvider, {
            setDefaultCouplerConfig: setDefaultCouplerConfig,
            setConfig: setConfig,
            addCoupler: addCoupler,
            getCouplers: getCouplers
        });

        this.$get = function ($timeout) {

            /**
             * Request processors
             * @type {Array<RequestCouplerProcessor>}
             */
            var processors = [];

            return {
                processRequest: processRequest,
                addCoupler: addCoupler,
                getCouplers: getCouplers
            };

            function processRequest(requestConfig) {
                if (!isEnabled()) {
                    requestConfig.continueDownNormalPipeline();
                    return;
                }

                var coupler = getCoupler(requestConfig);
                if (!coupler) {
                    requestConfig.continueDownNormalPipeline(); // normal pipeline
                    return;
                }

                getOrCreateProcessor(coupler).addRequest(requestConfig);
            }

            function getCoupler(requestConfig) {
                for (var i = 0; i < couplers.length; i++) {
                    var coupler = couplers[i];
                    if (coupler.check(requestConfig)) {
                        return coupler;
                    }
                }
            }

            function getOrCreateProcessor(coupler) {
                for (var i = 0; i < processors.length; i++) {
                    if (processors[i].getCoupler() === coupler) {
                        return processors[i];
                    }
                }
                var newProcessor = new RequestCouplerProcessor(coupler);
                processors.push(newProcessor);
                return newProcessor;
            }

            function RequestCouplerProcessor(_coupler) {
                var coupler = _coupler;
                var requests = [];
                var me = this;

                // start timer
                var timeout = $timeout(send, coupler.delay || defaultDelay, false);

                angular.extend(this, {
                    getCoupler: getCoupler,
                    addRequest: addRequest
                });

                function getCoupler() {
                    return coupler;
                }

                function addRequest(request) {
                    requests.push(request);
                    if (coupler.maxCouplerQueueSize > 0 && requests.length >= coupler.maxCouplerQueueSize) {
                        $timeout.cancel(timeout);
                        send();
                    }
                }

                function send() {
                    timeout = undefined;
                    // remove processor from processors
                    var di = processors.indexOf(me);
                    if (di > -1) {
                        processors.splice(di, 1);
                    }

                    // check limitations
                    if (coupler.minCouplerQueueSize > 0 && requests.length < coupler.minCouplerQueueSize) {
                        // should let the request continue normally
                        angular.forEach(requests, function (request) {
                            request.continueDownNormalPipeline();
                        });
                        return;
                    }
                    coupler.process(requests);
                }
            }
        }
    })

    .config(function ($provide) {
        $provide.decorator('$httpBackend', [
            '$delegate',
            'requestCoupler',
            function ($delegate, requestCoupler) {
                var $httpBackendFn = function (method, url, post, callback, headers, timeout, withCredentials, responseType) {
                    var self = this;
                    var callArgs = arguments;

                    requestCoupler.processRequest({
                        method: method,
                        url: url,
                        data: post,
                        callback: callback,
                        headers: headers,
                        timeout: timeout,
                        withCredentials: withCredentials,
                        responseType: responseType,
                        continueDownNormalPipeline: function () {
                            $delegate.apply(self, callArgs);
                        }
                    });
                };

                // If we are testing using angular-mocks we need to provide their special methods
                // on the function we are returning otherwise your tests won't work :-(.
                if (angular.mock) {
                    angular.forEach($delegate, function (fn, key) {
                        $httpBackendFn[key] = fn;
                    });
                }

                return $httpBackendFn;
            }
        ]);
    })

;